import React, { useState } from "react";
import { Hammer, ListChecks, MessageCircleQuestion } from "lucide-react";

const Question = ({ q, value, onPick, idx }) => (
  <div className="space-y-2" data-testid={`plan-question-${idx}`}>
    <p className="text-sm text-slate-700 flex gap-2"><MessageCircleQuestion size={14} className="mt-0.5 shrink-0 text-indigo-600" />{q.text}</p>
    <div className="flex flex-wrap gap-1.5 pl-6">
      {q.options.map((o, i) => (
        <button key={o} type="button" onClick={() => onPick(value === o ? null : o)} data-testid={`plan-question-${idx}-option-${i}`}
          className={`px-2.5 py-1 rounded-full border text-xs transition-colors ${value === o ? "border-indigo-400 bg-indigo-100 text-white" : "border-slate-300 text-slate-500 hover:text-white hover:border-slate-400"}`}>
          {o}
        </button>
      ))}
    </div>
  </div>
);

const composeReply = (plan, answers, notes) => {
  const lines = ["Build the plan above."];
  if (plan.questions.length) {
    lines.push("My answers:");
    plan.questions.forEach((q) => lines.push(`- ${q.text} → ${answers[q.id] || "your call"}`));
  }
  if (notes.trim()) lines.push(`Extra notes: ${notes.trim()}`);
  return lines.join("\n");
};

export const PlanCard = ({ msg, actionable, onApprove }) => {
  const plan = msg.plan || { summary: msg.content, steps: [], questions: [] };
  const [answers, setAnswers] = useState({});
  const [notes, setNotes] = useState("");
  return (
    <div className="space-y-4" data-testid="plan-card">
      <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-indigo-600"><ListChecks size={13} /> Plan</div>
      {plan.summary && <p className="leading-relaxed text-slate-700">{plan.summary}</p>}
      {plan.steps.length > 0 && (
        <ol className="space-y-1.5" data-testid="plan-steps">
          {plan.steps.map((s, i) => (
            <li key={i} className="flex gap-2.5 text-sm text-slate-600">
              <span className="w-5 h-5 shrink-0 rounded-md bg-slate-100 text-[10px] font-mono text-slate-500 flex items-center justify-center">{i + 1}</span>{s}
            </li>
          ))}
        </ol>
      )}
      {actionable && plan.questions.map((q, i) => (
        <Question key={q.id} q={q} idx={i} value={answers[q.id]} onPick={(v) => setAnswers({ ...answers, [q.id]: v })} />
      ))}
      {actionable && (
        <>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} placeholder="Anything else? (optional)" data-testid="plan-notes-input"
            className="w-full resize-none rounded-lg bg-slate-50 border border-slate-200 px-3 py-2 text-sm text-slate-700 outline-none focus:border-indigo-400" />
          <button type="button" onClick={() => onApprove(composeReply(plan, answers, notes))} data-testid="plan-approve-button"
            className="w-full h-10 rounded-lg bg-slate-900 text-white text-sm font-semibold flex items-center justify-center gap-2 hover:bg-slate-700 transition-colors">
            <Hammer size={14} /> Build this plan
          </button>
        </>
      )}
    </div>
  );
};

export default PlanCard;
